export default "__VITE_ASSET__a601d258__"